var A = Object.defineProperty, E = Object.defineProperties;
var P = Object.getOwnPropertyDescriptors;
var f = Object.getOwnPropertySymbols;
var O = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
var u = (r, o, m) => o in r ? A(r, o, { enumerable: !0, configurable: !0, writable: !0, value: m }) : r[o] = m, s = (r, o) => {
  for (var m in o || (o = {}))
    O.call(o, m) && u(r, m, o[m]);
  if (f)
    for (var m of f(o))
      n.call(o, m) && u(r, m, o[m]);
  return r;
}, y = (r, o) => E(r, P(o));
var T = (r, o) => {
  var m = {};
  for (var t in r)
    O.call(r, t) && o.indexOf(t) < 0 && (m[t] = r[t]);
  if (r != null && f)
    for (var t of f(r))
      o.indexOf(t) < 0 && n.call(r, t) && (m[t] = r[t]);
  return m;
};
import { jsxs as S, jsx as B } from "react/jsx-runtime";
import g from "react";
import { buttonPropTypes as h } from "./common.es.js";
import * as w from "./style.es.js";
import { Button as z, Loading as M } from "./style.es.js";
import { Icon as U } from "../../DataDisplay/Icon/Icon.es.js";
import { BUTTON_COLOR as V } from "../../../constants/color.es.js";
import { COMPONENT_SIZE as Z } from "../../../constants/sizes.es.js";
import { COLOR_VARIANT as $ } from "../../../constants/colorVariant.es.js";
const i = g.forwardRef((c, j) => {
  var a = c, {
    block: r = !1,
    children: o,
    color: m = V.primary,
    disabled: t = !1,
    endIcon: e = null,
    endIconProps: N = {},
    error: R = !1,
    loading: l = !1,
    onClick: d,
    rounded: x = !1,
    size: C = Z.md,
    startIcon: p = null,
    uppercase: L = !1,
    variant: _ = $.contained
  } = a, b = T(a, [
    "block",
    "children",
    "color",
    "disabled",
    "endIcon",
    "endIconProps",
    "error",
    "loading",
    "onClick",
    "rounded",
    "size",
    "startIcon",
    "uppercase",
    "variant"
  ]);
  return /* @__PURE__ */ S(z, y(s({ size: C, color: R ? "error" : m, disabled: t || l, rounded: x, onClick: d, variant: _, block: r, uppercase: L }, b), { ref: j, order: e ? 1 : p ? 0 : null, children: [
    l ? /* @__PURE__ */ B(M, { size: "sm" }) : p && p,
    o,
    e && typeof e == "string" ? /* @__PURE__ */ B(U, s({ name: e }, N)) : e
  ] }));
});
i.S = w;
i.displayName = "Button";
i.propTypes = h;
export {
  i as Button
};
//# sourceMappingURL=Button.es.js.map
